/** Лига в состоянии игрока. */
import { UInt } from "../../common";
import { z } from "zod";

/** Лига в состоянии игрока: ступень (0 — нижняя) и незабранные кристаллы. */
export const LeagueBrief = z.object({ tier: UInt, unclaimed: UInt });
export type LeagueBrief = z.infer<typeof LeagueBrief>;

/** Поля {@link PlayerState}. */
export const leagueFields = {
  /** Лига; `null` — гость или лиг нет в данных баланса. Без поля (старый сервер во время выката) — тоже `null`. */
  league: LeagueBrief.nullable().default(null),
};
